import Vue from 'vue';
import App from './App.vue';
import Vant from 'vant';
import 'vant/lib/index.css';
import { normalizeLocale, applyVantLocale } from '@/common/locale';
import router from './router';
import http from './http';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import common from './common/function'
import 'swiper/swiper-bundle.css'
import store from './store'
import VueI18n from 'vue-i18n';
import { Icon } from 'vant';
import 'video.js/dist/video-js.css'
import VueCookies from 'vue-cookies'
Vue.prototype.$http = http
Vue.prototype.common = common
Vue.config.productionTip = false

// KissMora: route all $toast(...) calls through our elegant KmToast.
// Supports: this.$toast('msg') / this.$toast({ message, type }) / this.$toast.success(msg) / .fail() / .error() / .info()
function _kmCall(arg){
  if(!window.$km || !window.$km.toast) return;
  if(typeof arg === 'string') return window.$km.toast({ msg: arg, type: 'info' });
  var msg = arg && (arg.message || arg.msg) || '';
  var type = arg && arg.type;
  // Map Vant types to KM types
  if(type === 'fail') type = 'error';
  if(type === 'loading') type = 'info';
  if(!type) type = 'info';
  return window.$km.toast({ msg: msg, type: type, duration: arg.duration });
}
var $kmToast = function(arg){ return _kmCall(arg); };
$kmToast.success = function(msg){ return window.$km && window.$km.toast && window.$km.toast.success(msg); };
$kmToast.fail    = function(msg){ return window.$km && window.$km.toast && window.$km.toast.error(msg); };
$kmToast.error   = function(msg){ return window.$km && window.$km.toast && window.$km.toast.error(msg); };
$kmToast.info    = function(msg){ return window.$km && window.$km.toast && window.$km.toast.info(msg); };
$kmToast.warn    = function(msg){ return window.$km && window.$km.toast && window.$km.toast.warn(msg); };
$kmToast.loading = function(msg){ return window.$km && window.$km.toast && window.$km.toast.info(msg || 'Loading…'); };
$kmToast.clear   = function(){ /* KmToast auto-dismisses; no-op for compat */ };
Vue.prototype.$toast = $kmToast;
Vue.use(VueAwesomeSwiper, /* { default options with global component } */)
Vue.use(Vant);
Vue.use(Icon);
Vue.use(VueI18n);
Vue.use(VueCookies)
const _savedLocale = normalizeLocale(localStorage.getItem('lang') || 'en');
localStorage.setItem('lang', _savedLocale);
document.documentElement.lang = _savedLocale;
applyVantLocale(_savedLocale);
const i18n = new VueI18n({
  globalInjection: true,
  locale: _savedLocale,
  fallbackLocale: 'en',
  silentFallbackWarn: true,
  silentTranslationWarn: true,
  messages: {
    en: require('./assets/languages/en.json'),
    zh: require('./assets/languages/zh.json'),
    ja: require('./assets/languages/ja.json'),
    kr: require('./assets/languages/kr.json'),
  }
});
new Vue({
  store,
  router,
  i18n,
  render: h => h(App),
}).$mount('#app')
